module.exports = __webpack_public_path__ + "img/protelBanner3.d2752f64.jpg";